var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissingPoiWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1967_6500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C8.14 2 5 5.14 5 9C5 13.2076 9.49633 19.0211 11.2818 21.1637C11.661 21.6188 12.339 21.6188 12.7182 21.1637C14.5037 19.0211 19 13.2076 19 9C19 5.14 15.86 2 12 2ZM12.88 14.875C12.88 15.3582 12.4882 15.75 12.005 15.75V15.75C11.5218 15.75 11.13 15.3582 11.13 14.875V14.875C11.13 14.3918 11.5218 14 12.005 14V14C12.4882 14 12.88 14.3918 12.88 14.875V14.875ZM13.0695 12.0331C12.8597 12.4684 12.4882 12.88 12.005 12.88V12.88C11.5218 12.88 11.1125 12.4806 11.2267 12.0111C11.7 10.0644 13.75 10.0568 13.75 8.5C13.75 7.54 12.96 6.75 12 6.75C11.3429 6.75 10.7654 7.12018 10.4664 7.66167C10.2328 8.08472 9.85825 8.5 9.375 8.5V8.5C8.89175 8.5 8.48881 8.10214 8.60842 7.63392C8.99479 6.12147 10.3688 5 12 5C13.93 5 15.5 6.57 15.5 8.5C15.5 10.3296 13.6713 10.7843 13.0695 12.0331Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1967_6500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingPoiWhite);
export default __webpack_public_path__ + "static/media/missing-poi-white.a349604a6c6fcf13cb1d0676d9c5e788.svg";
export { ForwardRef as ReactComponent };